/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgCaptchaOutline = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 17",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.379 4.457a4.995 4.995 0 0 0-6.54 1.619l-.833-.555a5.995 5.995 0 1 1-.853 1.98l.974.225a4.995 4.995 0 1 0 7.252-3.27Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.793 5.077 4.201 2.4l-.989-.15-.558 3.665 3.666.558.15-.99-2.677-.406Zm7.061 2.352L7.25 11.032 5.396 9.18l.708-.707L7.25 9.618l2.896-2.896.708.707Z"
})));

export default SvgCaptchaOutline;